import PropTypes from 'prop-types';
import React from 'react';
import {
  Col,
  Grid,
  Row,
} from 'react-bootstrap';
import ConfirmPasswordFormField from './ConfirmPasswordFormField.jsx';
import CurrentPasswordFormField from './CurrentPasswordFormField.jsx';
import generalComplexityRule from './generalComplexityRule.js';
import languagesPropType from './languagesPropType.js';
import minimumCharacterRule from './minimumCharacterRule.js';
import NewPasswordFormField from './NewPasswordFormField.jsx';
import passwordAnalyzer from './passwordAnalyzer.js';
import PasswordStrengthMeter from './PasswordStrengthMeter.jsx';
import styles from './ModalView.css';

class ModalView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmPassword: props.confirmPassword,
      rulesResults: [],
      shouldShowModal: false,
      strengthScore: 0,
    };
  }

  componentDidMount() {
    this.analyzePassword('');
  }

  analyzePassword = (value) => {
    let {
      rules,
    } = this.props;

    let result = passwordAnalyzer(value, rules);

    this.setState({
      rulesResults: result.rulesResults,
      strengthScore: result.strengthScore,
    });
  }

  handleNewPasswordChanged = (value) => {
    let {
      onChangeNewPassword,
    } = this.props;

    onChangeNewPassword(value, this.state.confirmPassword);
    this.analyzePassword(value);
    this.validateConfirmPasswordField();
  }

  handleConfirmPasswordChanged = (value) => {
    let {
      onChangeNewPassword,
    } = this.props;

    this.setState({
      confirmPassword: value,
    });
    onChangeNewPassword(this.props.newPassword, value);
  }

  render() {
    let {
      currentPassword,
      currentPasswordFailed,
      language,
      newPassword,
      onChangeCurrentPassword,
      requireCurrentPassword,
    } = this.props;
    let {
      confirmPassword,
      rulesResults,
      strengthScore,
    } = this.state;

    return (
      <Grid fluid={true}>
        <Row>
          <Col md={6} style={{paddingRight: '6px'}}>
            <div
              id="passwordInputs"
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: '250px',
                justifyContent: 'center',
              }}
            >
              {
                requireCurrentPassword &&
                <CurrentPasswordFormField
                  currentPasswordFailed={currentPasswordFailed}
                  language={language}
                  onChange={onChangeCurrentPassword}
                  value={currentPassword}
                />
              }
              <NewPasswordFormField
                autoFocus={!requireCurrentPassword}
                language={language}
                onChange={this.handleNewPasswordChanged}
                rulesResults={rulesResults}
                value={newPassword}
              />
              <ConfirmPasswordFormField
                newPassword={newPassword}
                language={language}
                onChange={this.handleConfirmPasswordChanged}
                onSetValidate={validate =>  this.validateConfirmPasswordField = validate}
                value={confirmPassword}
              />
            </div>
          </Col>

          <Col md={6} className={styles.passwordMeterColumn}>
            <div className={styles.passwordMeterContainer}>
              <PasswordStrengthMeter
                language={language}
                rulesResults={rulesResults}
                strengthScore={strengthScore}
              />
            </div>
          </Col>
        </Row>
      </Grid>
    );
  }
}

ModalView.defaultProps = {
  confirmPassword: '',
  language: languagesPropType.defaultProp,
  rules: [
    minimumCharacterRule(8),
    generalComplexityRule(),
  ]
};

ModalView.propTypes = {
  language: languagesPropType.propType,
  confirmPassword: PropTypes.string,
  currentPassword: PropTypes.string,
  currentPasswordFailed: PropTypes.bool,
  newPassword: PropTypes.string.isRequired,
  onChangeCurrentPassword: PropTypes.func,
  onChangeNewPassword: PropTypes.func.isRequired,
  requireCurrentPassword: PropTypes.bool,
  rules: PropTypes.arrayOf(
    PropTypes.shape({
      test: PropTypes.func.isRequired,
    })
  ),
};

export default ModalView;